











import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

import { Match } from "@/types";
import TimelineContainer from "@/components/timeline/TimelineContainer.vue";

@Component({
  components: { TimelineContainer }
})
export default class TimelineCard extends Vue {
  @Getter("matches/flatten")
  private flatten!: Match[];
}
